import { getWheels, getSizes } from '../helpers/helpers';

getWheels.forEach(wheel => {
  wheel.addEventListener('click', () => {
    getWheels.forEach(activeWheel => {
      activeWheel.removeAttribute('active');
    });
    getSizes.forEach(getSize => {
      getSize.setAttribute('size', wheel.getAttribute('size'));
    });
    wheel.setAttribute('active', '');
  });
});
